import React from 'react';

export default function Login(props) {
  return <div className='km__l--login-container'>{props.children}</div>;
}
